import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex flex-col items-center justify-center px-4 py-20 overflow-hidden bg-[#111111]" data-id="element-112">
      {/* Background Texture */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gray-700 via-[#111111] to-[#111111]" data-id="element-113" />

      <div className="relative z-10 max-w-6xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-114">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col space-y-6 text-center lg:text-left" data-id="element-115">
          <div className="inline-block px-3 py-1 bg-gray-800 border border-gray-700 rounded text-xs font-bold tracking-widest text-accent uppercase w-fit mx-auto lg:mx-0" data-id="element-116">
            Metabolic Engineering Protocol
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-117">
            Eating "Clean," Losing Weight, and Still{' '}
            <span className="text-accent" data-id="element-118">Pre-Diabetic?</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 font-medium leading-relaxed" data-id="element-119">
            Finally... A Metabolic Engineering Protocol for the Man Whose Labs
            Don't Match His Hard Work.
          </p>

          <div className="pt-8" data-id="element-120">
            <button onClick={() => document.getElementById('final-cta')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full md:w-auto px-8 py-4 bg-accent hover:bg-[#d55515] text-white text-lg font-bold rounded shadow-lg glow-orange transition-all duration-300 transform hover:scale-105 flex items-center justify-center uppercase tracking-wider" data-id="element-121">
              Get The Protocol $6.36
            </button>
            <p className="mt-4 text-sm text-gray-500" data-id="element-122">
              Instant Digital Download • Secure Checkout
            </p>
          </div>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative flex justify-center" data-id="element-123">
          <div className="relative w-full max-w-md aspect-[4/5] md:aspect-square lg:aspect-[4/5]" data-id="element-124">
            <div className="absolute inset-0 bg-accent/20 blur-3xl rounded-full opacity-30 transform translate-y-10" data-id="element-125" />
            <img src="https://cdn.magicpatterns.com/uploads/2ZH9LKbT3LtVRi8TwvUxsg/heylloyd-image-1771382677325.png" alt="A1C Shockproof Manual on Tablet" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-126" />
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center gap-2" data-id="element-127">
        <span className="text-xs text-gray-500 uppercase tracking-widest" data-id="element-128">
          The Truth Below
        </span>
        <div className="w-px h-12 bg-gradient-to-b from-accent to-transparent" data-id="element-129" />
      </motion.div>
    </section>;
}